import Icon from '@ant-design/icons';
import { ReactComponent as starIcon } from "./star.svg";

const StarIcon = () => (
  <Icon component={starIcon} style={{ fontSize: "12px" }} />
);

export default StarIcon;